import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

import { IconProps } from '../icons'

const Wallet = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg width={`${size}px`} height={`${size}px`} fill="none" {...props}>
    <G clipPath="url(#a)">
      <Path
        d="M61.667 11.49H18.333C8.213 11.5.011 19.701 0 29.822v3.333c0 .92.746 1.666 1.667 1.666h76.666c.92 0 1.667-.746 1.667-1.666v-3.333C79.99 19.702 71.787 11.5 61.667 11.489Z"
        fill="#8691A8"
      />
      <Path
        d="M68.157 22.41 61.1 8.295c-2.881-5.763-9.889-8.1-15.652-5.218-.105.052-.208.106-.311.161l-34.26 18.447a1.667 1.667 0 0 0 .79 3.133h55a1.667 1.667 0 0 0 1.49-2.413v.003Z"
        fill="#596379"
      />
      <Path
        d="M11.667 21.49h56.666C74.777 21.49 80 26.712 80 33.155v33.333c0 6.444-5.223 11.667-11.667 11.667H11.667C5.223 78.156 0 72.932 0 66.489V33.156c0-6.444 5.223-11.667 11.667-11.667Z"
        fill="#ECEFF5"
      />
      <Path
        d="M78.333 38.156H65c-6.443.004-11.664 5.23-11.66 11.673.003 6.439 5.221 11.657 11.66 11.66h13.333c.92 0 1.667-.746 1.667-1.666v-20c0-.92-.746-1.667-1.667-1.667Z"
        fill="#5E9FFF"
      />
      <Path d="M65 54.822a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z" fill="#fff" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h80v80H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default Wallet
